module.exports = require('./helpers/bundle-url').getBundleURL('bccYT') + "logo.7718c6df.svg";